import React from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { SelectionCard } from '@vio/atlas/SelectionCard';
const _exp = /*#__PURE__*/() => SelectionCard;
const SelectionCardWrapper = /*#__PURE__*/styled(_exp())({
  name: "SelectionCardWrapper",
  class: "s9q6smk",
  propsAsIs: true
});
interface FacetCardProps {
  icon: React.ReactNode;
  label: React.ReactNode;
  isSelected: boolean;
  onSelectCard: () => void;
}
export const FacetCard: React.FC<FacetCardProps> = ({
  icon,
  label,
  isSelected,
  onSelectCard
}) => {
  return <SelectionCardWrapper type="checkbox" name={label as string} selected={isSelected} withControlButton onChange={() => onSelectCard()} className={cx(!isSelected && '--hide-checkbox')} icon={icon} isVertical title={label} />;
};

require("./FacetCard.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./FacetCard.tsx");